/**
 * Wrapper de página que aplica estilos según la configuración (tabla configurations)
 */
import { useConfig } from '../context/ConfigContext';

function ConfigurablePage({ children, className = '' }) {
  const { config } = useConfig();

  const fontStyle = config?.fontColor ? { color: config.fontColor } : {};
  const fontFamily = config?.fontFamily ? { fontFamily: config.fontFamily } : {};

  return (
    <div
      className={className}
      style={{ ...fontStyle, ...fontFamily }}
    >
      {children}
    </div>
  );
}

export default ConfigurablePage;
